import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/src/entities/auth-user/ui/AuthWrapper/AuthWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
